module.exports = __webpack_public_path__ + "img/SC.8afe6ea3.svg";